import React, { useEffect, useRef, useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import { FaSlidersH } from 'react-icons/fa';
import {
    ActiveDropdownOption,
    DropdownMenu,
    DropdownMenuRight,
    DropdownOption,
    DropdownWrapper,
    FiltrarCursoContainer,
    FilterLeftGroup,
    FiltroContainer,
    OrdenarContainer,
    Span,
} from './FiltrarCurso.styled';

type StatusFilter = 'TODOS' | 'NAO_INICIADOS' | 'EM_ANDAMENTO' | 'CONCLUIDOS';

type SortOption = 'MAIS_NOVO' | 'MAIS_ANTIGO' | 'A_Z' | 'Z_A';

interface IFiltrarCursoProps {
    isLogged?: boolean;

    statusFilter?: StatusFilter;
    onStatusFilterChange?: (filter: StatusFilter) => void;

    sortOption?: SortOption | null;
    onSortOptionChange?: (option: SortOption | null) => void;
}

export function FiltrarCurso({
    isLogged = false,
    statusFilter = 'TODOS',
    onStatusFilterChange,
    sortOption = null,
    onSortOptionChange,
}: IFiltrarCursoProps) {
    const [filterOpen, setFilterOpen] = useState(false);
    const [sortOpen, setSortOpen] = useState(false);

    const filterRef = useRef<HTMLDivElement>(null);
    const sortRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as Node;

            if (filterRef.current && !filterRef.current.contains(target)) {
                setFilterOpen(false);
            }

            if (sortRef.current && !sortRef.current.contains(target)) {
                setSortOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const iconProps = {
        color: '#003C78',
    };

    const controlsDisabled = !isLogged;

    const handleStatusChange = (filter: StatusFilter) => {
        const nextFilter = statusFilter === filter ? 'TODOS' : filter;

        onStatusFilterChange?.(nextFilter);

        setFilterOpen(false);
    };

    const handleSortChange = (option: SortOption) => {
        /*
         * Clicar novamente na mesma ordenação retorna ao
         * comportamento padrão da tela.
         */
        if (sortOption === option) {
            onSortOptionChange?.(null);
        } else {
            onSortOptionChange?.(option);
        }

        setSortOpen(false);
    };

    const filterLabelMap: Record<StatusFilter, string> = {
        TODOS: 'Filtrar',
        NAO_INICIADOS: 'Não iniciados',
        EM_ANDAMENTO: 'Em andamento',
        CONCLUIDOS: 'Concluídos',
    };

    const filterLabel = filterLabelMap[statusFilter];

    return (
        <FiltrarCursoContainer>
            <FilterLeftGroup>
                <DropdownWrapper ref={filterRef}>
                    <FiltroContainer
                        onClick={() => {
                            if (controlsDisabled) {
                                return;
                            }

                            setFilterOpen(prev => !prev);
                            setSortOpen(false);
                        }}
                        $disabled={controlsDisabled}
                    >
                        <FaSlidersH {...iconProps} />
                        <Span>{filterLabel}</Span>
                    </FiltroContainer>

                    {filterOpen && (
                        <DropdownMenu>
                            {statusFilter === 'TODOS' ? (
                                <ActiveDropdownOption onClick={() => handleStatusChange('TODOS')}>Todos</ActiveDropdownOption>
                            ) : (
                                <DropdownOption onClick={() => handleStatusChange('TODOS')}>Todos</DropdownOption>
                            )}

                            {statusFilter === 'NAO_INICIADOS' ? (
                                <ActiveDropdownOption onClick={() => handleStatusChange('NAO_INICIADOS')}>Não iniciados</ActiveDropdownOption>
                            ) : (
                                <DropdownOption onClick={() => handleStatusChange('NAO_INICIADOS')}>Não iniciados</DropdownOption>
                            )}

                            {statusFilter === 'EM_ANDAMENTO' ? (
                                <ActiveDropdownOption onClick={() => handleStatusChange('EM_ANDAMENTO')}>Em andamento</ActiveDropdownOption>
                            ) : (
                                <DropdownOption onClick={() => handleStatusChange('EM_ANDAMENTO')}>Em andamento</DropdownOption>
                            )}

                            {statusFilter === 'CONCLUIDOS' ? (
                                <ActiveDropdownOption onClick={() => handleStatusChange('CONCLUIDOS')}>Concluídos</ActiveDropdownOption>
                            ) : (
                                <DropdownOption onClick={() => handleStatusChange('CONCLUIDOS')}>Concluídos</DropdownOption>
                            )}
                        </DropdownMenu>
                    )}
                </DropdownWrapper>
            </FilterLeftGroup>

            <DropdownWrapper ref={sortRef}>
                <OrdenarContainer
                    onClick={() => {
                        if (controlsDisabled) {
                            return;
                        }

                        setSortOpen(prev => !prev);
                        setFilterOpen(false);
                    }}
                    $disabled={controlsDisabled}
                >
                    <Span>Ordenar por</Span>
                    <FiChevronDown {...iconProps} />
                </OrdenarContainer>

                {sortOpen && (
                    <DropdownMenuRight>
                        {sortOption === 'MAIS_NOVO' ? (
                            <ActiveDropdownOption onClick={() => handleSortChange('MAIS_NOVO')}>Mais novo → mais antigo</ActiveDropdownOption>
                        ) : (
                            <DropdownOption onClick={() => handleSortChange('MAIS_NOVO')}>Mais novo → mais antigo</DropdownOption>
                        )}

                        {sortOption === 'MAIS_ANTIGO' ? (
                            <ActiveDropdownOption onClick={() => handleSortChange('MAIS_ANTIGO')}>Mais antigo → mais novo</ActiveDropdownOption>
                        ) : (
                            <DropdownOption onClick={() => handleSortChange('MAIS_ANTIGO')}>Mais antigo → mais novo</DropdownOption>
                        )}

                        {sortOption === 'A_Z' ? (
                            <ActiveDropdownOption onClick={() => handleSortChange('A_Z')}>A-Z</ActiveDropdownOption>
                        ) : (
                            <DropdownOption onClick={() => handleSortChange('A_Z')}>A-Z</DropdownOption>
                        )}

                        {sortOption === 'Z_A' ? (
                            <ActiveDropdownOption onClick={() => handleSortChange('Z_A')}>Z-A</ActiveDropdownOption>
                        ) : (
                            <DropdownOption onClick={() => handleSortChange('Z_A')}>Z-A</DropdownOption>
                        )}
                    </DropdownMenuRight>
                )}
            </DropdownWrapper>
        </FiltrarCursoContainer>
    );
}
